"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.POLLING_INTERVALS_MILLIS = void 0;
exports.POLLING_INTERVALS_MILLIS = {
    HVAC: 30 * 1000,
};
